import AppStoreButton, { StoreEnum } from "@/components/app-store-button";
import HeadingWithHighlight from "@/components/heading-with-highlight";

import { ExperiencesIcon, ReviewsIcon, RoomsIcon } from "./icons";
import type { PropertyType } from "./property";
import Property from "./property";

export interface StatsProps {
  properties: Omit<PropertyType, "icon">[];
  title: string;
}

const ICONS = [
  <RoomsIcon key="rooms" />,
  <ExperiencesIcon key="experiences" />,
  <ReviewsIcon key="reviews" />,
];

export default function Stats({ title, properties }: StatsProps) {
  return (
    <section>
      <div className="container mt-[50px] md:mt-[150px]">
        <div className="flex flex-col md:flex-row md:justify-between">
          <div className="shrink-0 md:w-[43%]">
            <HeadingWithHighlight className="md:text-left" title={title} />
            <div className="mt-[50px] flex gap-[13px] md:mt-10 md:gap-4">
              <AppStoreButton className="w-1/2 rounded-[4px] md:w-[161px]" />
              <AppStoreButton
                className="w-1/2 rounded-[4px] md:w-[161px]"
                store={StoreEnum.GOOGLE}
              />
            </div>
          </div>
          <div className="mt-[50px] md:mt-0">
            <div className="flex flex-col gap-[25px] md:flex-row">
              {properties.map((property, index) => (
                <Property icon={ICONS[index]} key={property.id} {...property} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
